// /*
//  * Farida Gupta - sitewide "Item added to cart" / "Item added to wishlist" growl toast
//  * (snippets/fg-notification-toast.liquid, Figma node 3772:15609).
//  *
//  * Cart: theme.js's <product-form> dispatches "variant:add" on the submitted form (bubbles to
//  * document) once /cart/add.js succeeds, with detail.items - the line(s) just added - so summing
//  * their quantities gives an accurate count even for a quantity-selector add. This fires for every
//  * add-to-cart entry point (product page, sticky bar, quick buy, product-card quick add), since
//  * they all go through the same <product-form>/<buy-buttons> pair.
//  *
//  * Wishlist: the Smart Wishlist app (assets.smartwishlist.webmarked.net, see
//  * fg-wishlist-reinit.js/fg-theme.css) exposes no documented "item added" event, but it does add a
//  * "bookmarked" class to the clicked #smartwishlist mount point on a successful add - already
//  * relied on by fg-theme.css's heart-fill animation. A MutationObserver watches for that class
//  * transition instead of a real event.
//  *
//  * That same "bookmarked" class is also set when the app syncs an *already*-wishlisted product's
//  * mount on page load/reinit (fg-wishlist-reinit.js's ReloadSmartWishlist() calls, e.g. after
//  * facets/load-more/predictive-search swap in fresh product cards) - to the observer that mutation
//  * looks identical to a real add, so it isn't enough on its own. isWishlistClickPending tracks
//  * whether the visitor clicked a #smartwishlist mount in the last few seconds; the observer only
//  * shows the toast while that's true, which a page-load/reinit sync never triggers.
//  *
//  * Listened on the capture phase (the `true` third argument) rather than the usual bubble phase, so
//  * this still sees the click even if the app's own click handler calls stopPropagation() on it
//  * (capture runs top-down, before the target's own bubble-phase handlers get a chance to).
//  */
// let isWishlistClickPending = false;
// let wishlistClickTimeoutId;

// document.addEventListener(
//   'click',
//   (event) => {
//     if (!event.target.closest('.smartwishlist')) {
//       return;
//     }

//     isWishlistClickPending = true;
//     clearTimeout(wishlistClickTimeoutId);
//     wishlistClickTimeoutId = setTimeout(() => {
//       isWishlistClickPending = false;
//     }, 3000);
//   },
//   true
// );

// const toast = document.getElementById('fg-notification-toast');
// const titleElement = toast?.querySelector('.fg-notification-toast__title');
// const messageElement = toast?.querySelector('.fg-notification-toast__message');
// const actionElement = toast?.querySelector('.fg-notification-toast__action');

// let dismissTimeoutId;

// function showToast({ title, message, actionText, actionHref, actionAriaControls }) {
//   if (!toast) {
//     return;
//   }

//   titleElement.textContent = title;
//   messageElement.textContent = message;

//   if (actionText) {
//     actionElement.textContent = actionText;
//     actionElement.href = actionHref || '#';
//     actionElement.hidden = false;

//     if (actionAriaControls) {
//       actionElement.setAttribute('aria-controls', actionAriaControls);
//     } else {
//       actionElement.removeAttribute('aria-controls');
//     }
//   } else {
//     actionElement.hidden = true;
//   }

//   toast.hidden = false;
//   requestAnimationFrame(() => toast.classList.add('fg-notification-toast--visible'));

//   clearTimeout(dismissTimeoutId);
//   dismissTimeoutId = setTimeout(hideToast, 4000);
// }

// function hideToast() {
//   if (!toast || toast.hidden) {
//     return;
//   }

//   clearTimeout(dismissTimeoutId);
//   toast.classList.remove('fg-notification-toast--visible');
//   setTimeout(() => {
//     toast.hidden = true;
//   }, 250);
// }

// toast?.querySelector('[data-fg-notification-toast-close]')?.addEventListener('click', hideToast);
// actionElement?.addEventListener('click', hideToast);

// document.addEventListener('variant:add', (event) => {
//   const itemCount = event.detail.items.reduce((total, item) => total + item.quantity, 0);
//   const { strings } = window.themeVariables;

//   showToast({
//     title: strings.cartToastTitle,
//     message: (itemCount === 1 ? strings.cartToastMessageOne : strings.cartToastMessageOther).replace(
//       '{{ count }}',
//       itemCount
//     ),
//     actionText: strings.viewBag,
//     // Same convention as the header's own cart link (sections/header.liquid): aria-controls lets
//     // <cart-drawer>'s own delegated click listener open it, with the plain /cart href left as a
//     // fallback for when the drawer isn't in the DOM (e.g. cart_type "message"/"page").
//     actionHref: `${window.Shopify.routes.root}cart`,
//     actionAriaControls: 'cart-drawer'
//   });
// });

// const wishlistObserver = new MutationObserver((mutations) => {
//   for (const mutation of mutations) {
//     const target = mutation.target;

//     if (!target.classList?.contains('smartwishlist') || !isWishlistClickPending) {
//       continue;
//     }

//     const wasBookmarked = mutation.oldValue?.split(' ').includes('bookmarked');
//     const isBookmarked = target.classList.contains('bookmarked');

//     if (isBookmarked && !wasBookmarked) {
//       isWishlistClickPending = false;
//       clearTimeout(wishlistClickTimeoutId);

//       const { strings } = window.themeVariables;

//       showToast({
//         title: strings.wishlistToastTitle,
//         message: strings.wishlistToastMessage,
//         actionText: strings.viewWishlist,
//         actionHref: window.themeVariables.settings.wishlistUrl
//       });
//     }
//   }
// });

// wishlistObserver.observe(document.body, {
//   attributes: true,
//   attributeFilter: ['class'],
//   attributeOldValue: true,
//   subtree: true
// });

// /*
//  * Sitewide "your bag has a sold-out item" echo (Figma node 3778:16476) - the header's cart-drawer
//  * (sections/cart-drawer.liquid) already renders its own compact notice
//  * (snippets/cart-sold-out-notice.liquid) for the first sold-out line item, on every page, but the
//  * drawer itself is closed by default so that notice is easy to never see. Reading
//  * data-product-title off that same (already server-rendered, so always current) element avoids
//  * re-deriving "is anything in the cart sold out" in JS via a separate /cart.js fetch.
//  *
//  * Skipped on the cart page itself (request.page_type "cart") - the page already shows the full
//  * banner version of this same notice (snippets/cart-sold-out-notice.liquid's non-compact branch),
//  * so a toast on top of it would just repeat what's already on screen.
//  */
// if (window.themeVariables.settings.pageType !== 'cart') {
//   const soldOutNotice = document.querySelector('.cart-drawer .fg-cart-sold-out-notice[data-product-title]');

//   if (soldOutNotice) {
//     const { strings } = window.themeVariables;

//     showToast({
//       title: strings.soldOutToastTitle,
//       message: strings.soldOutToastMessage.replace('{{ title }}', soldOutNotice.dataset.productTitle),
//       actionText: strings.viewBag,
//       actionHref: `${window.Shopify.routes.root}cart`,
//       actionAriaControls: 'cart-drawer'
//     });
//   }
// }


// Custom Support Flits - 18-09-2026..
let isWishlistClickPending = false;
let wishlistClickTimeoutId;

document.addEventListener(
  'click',
  (event) => {
    if (!event.target.closest('.smartwishlist')) {
      return;
    }

    isWishlistClickPending = true;
    clearTimeout(wishlistClickTimeoutId);
    wishlistClickTimeoutId = setTimeout(() => {
      isWishlistClickPending = false;
    }, 3000);
  },
  true
);

const toast = document.getElementById('fg-notification-toast');
const titleElement = toast?.querySelector('.fg-notification-toast__title');
const messageElement = toast?.querySelector('.fg-notification-toast__message');
const actionElement = toast?.querySelector('.fg-notification-toast__action');

let dismissTimeoutId;

function showToast({ title, message, actionText, actionHref, actionAriaControls }) {
  if (!toast) {
    return;
  }

  titleElement.textContent = title;
  messageElement.textContent = message;

  if (actionText) {
    actionElement.textContent = actionText;
    actionElement.href = actionHref || '#';
    actionElement.hidden = false;

    if (actionAriaControls) {
      actionElement.setAttribute('aria-controls', actionAriaControls);
    } else {
      actionElement.removeAttribute('aria-controls');
    }
  } else {
    actionElement.hidden = true;
  }

  toast.hidden = false;
  requestAnimationFrame(() => toast.classList.add('fg-notification-toast--visible'));

  clearTimeout(dismissTimeoutId);
  dismissTimeoutId = setTimeout(hideToast, 4000);
}

function hideToast() {
  if (!toast || toast.hidden) {
    return;
  }

  clearTimeout(dismissTimeoutId);
  toast.classList.remove('fg-notification-toast--visible');
  setTimeout(() => {
    toast.hidden = true;
  }, 250);
}

toast?.querySelector('[data-fg-notification-toast-close]')?.addEventListener('click', hideToast);
actionElement?.addEventListener('click', hideToast);

document.addEventListener('variant:add', (event) => {
  if (!window.themeVariables.settings.enableCartNotificationToast) {
    return;
  }

  const itemCount = event.detail.items.reduce((total, item) => total + item.quantity, 0);
  const { strings } = window.themeVariables;

  showToast({
    title: strings.cartToastTitle,
    message: (itemCount === 1 ? strings.cartToastMessageOne : strings.cartToastMessageOther).replace(
      '{{ count }}',
      itemCount
    ),
    actionText: strings.viewBag,
    // Same convention as the header's own cart link (sections/header.liquid): aria-controls lets
    // <cart-drawer>'s own delegated click listener open it, with the plain /cart href left as a
    // fallback for when the drawer isn't in the DOM (e.g. cart_type "message"/"page").
    actionHref: `${window.Shopify.routes.root}cart`,
    actionAriaControls: 'cart-drawer'
  });
});

// Custom Support Flits - 18-09-2026
document.addEventListener('theme:wishlist:already-added', () => {
  const { strings } = window.themeVariables;

  showToast({
    title: strings.wishlistToastTitle,
    message: strings.wishlistAlreadyAddedMessage || 'This item is already in your wishlist',
    actionText: strings.viewWishlist,
    actionHref: window.themeVariables.settings.wishlistUrl
  });
});
// Custom Support Flits - 18-09-2026 code Ends here..

const wishlistObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    const target = mutation.target;

    if (!target.classList?.contains('smartwishlist') || !isWishlistClickPending) {
      continue;
    }

    const wasBookmarked = mutation.oldValue?.split(' ').includes('bookmarked');
    const isBookmarked = target.classList.contains('bookmarked');

    if (isBookmarked && !wasBookmarked) {
      isWishlistClickPending = false;
      clearTimeout(wishlistClickTimeoutId);

      const { strings } = window.themeVariables;

      showToast({
        title: strings.wishlistToastTitle,
        message: strings.wishlistToastMessage,
        actionText: strings.viewWishlist,
        actionHref: window.themeVariables.settings.wishlistUrl
      });
    }
  }
});

wishlistObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  attributeOldValue: true,
  subtree: true
});

/*
 * Sitewide "your bag has a sold-out item" echo (Figma node 3778:16476) - the header's cart-drawer
 * (sections/cart-drawer.liquid) already renders its own compact notice
 * (snippets/cart-sold-out-notice.liquid) for the first sold-out line item, on every page, but the
 * drawer itself is closed by default so that notice is easy to never see. Reading
 * data-product-title off that same (already server-rendered, so always current) element avoids
 * re-deriving "is anything in the cart sold out" in JS via a separate /cart.js fetch.
 *
 * Skipped on the cart page itself (request.page_type "cart") - the page already shows the full
 * banner version of this same notice (snippets/cart-sold-out-notice.liquid's non-compact branch,
 * with its own REMOVE ITEM action), so a toast on top of it would just duplicate what's already
 * on screen. Every other page: shown only once - a "fg_sold_out_toast_seen" cookie is set the
 * first time it fires, so it doesn't reappear on the next page the visitor browses to (home,
 * product, collection, ...) once they've already seen it once.
 */
/*
 * Server-rendered "show on load" toast - for flows that finish with a full page reload instead of a
 * JS event, e.g. sections/fg-contact-us.liquid's contact form, which outputs a hidden
 * [data-fg-notification-toast-on-load] element when form.posted_successfully? is true. Runs before
 * the sold-out echo below, which is skipped when this fires so it doesn't immediately replace it.
 */
const onLoadToastElement = document.querySelector('[data-fg-notification-toast-on-load]');

if (onLoadToastElement) {
  showToast({
    title: onLoadToastElement.dataset.title,
    message: onLoadToastElement.dataset.message
  });

  // Shopify flags a successful contact submit via the "?contact_posted=true" redirect param, which
  // is what makes form.posted_successfully? true - drop it from the URL so a refresh or back/forward
  // doesn't show the toast again.
  const url = new URL(window.location.href);

  if (url.searchParams.has('contact_posted')) {
    url.searchParams.delete('contact_posted');
    window.history.replaceState(window.history.state, '', url);
  }
}

if (!onLoadToastElement && window.themeVariables.settings.pageType !== 'cart') {
  const soldOutNotice = document.querySelector('.cart-drawer .fg-cart-sold-out-notice[data-product-title]');
  const hasSeenSoldOutToast = document.cookie.split('; ').includes('fg_sold_out_toast_seen=true');

  if (soldOutNotice && !hasSeenSoldOutToast) {
    const { strings } = window.themeVariables;

    showToast({
      title: strings.soldOutToastTitle,
      message: strings.soldOutToastMessage.replace('{{ title }}', soldOutNotice.dataset.productTitle),
      actionText: strings.viewBag,
      actionHref: `${window.Shopify.routes.root}cart`,
      actionAriaControls: 'cart-drawer'
    });

    document.cookie = 'fg_sold_out_toast_seen=true; path=/';
  }
}
// Custom Support Flits - 18-09-2026 code ends here..